import type { FC } from 'react';
import { Icon } from '@iconify/react';
import { Stack, StackProps, Typography, useTheme } from '@mui/material';

export type PlaceholderProps = {
  message: string;
  icon: string;
  size?: 'tiny' | 'small' | 'large';
  secondary?: boolean;
} & StackProps;

export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { message, icon, size = 'small', secondary, ...other } = props;

  const theme = useTheme();
  const color = secondary
    ? theme.palette.text.secondary
    : theme.palette.text.primary;

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={size === 'large' ? 4 : 2}
      minHeight={size === 'tiny' ? 100 : 200}
      {...other}
    >
      <Icon
        icon={icon}
        style={{
          color,
          fontSize:
            size === 'large' ? '48px' : size === 'small' ? '24px' : '18px',
          opacity: size === 'large' ? 0.6 : 0.8
        }}
      />
      <Typography
        variant={size === 'large' ? 'body1' : 'body2'}
        color={color}
      >
        {message}
      </Typography>
    </Stack>
  );
};
